import Bear from "./Bear.png";
import Bird from "./Bird.png";
import Elephant from "./Elephant.png";
import Fox from "./Fox.png";
import Frog from "./Frog.png";
import Giraffe from "./Giraffe.png";
import Lion from "./Lion.png";
import Panda from "./Panda.png";
import Rabbit from "./Rabbit.png";

const avatarMap = {
  Bear,
  Bird,
  Elephant,
  Fox,
  Frog,
  Giraffe,
  Lion,
  Panda,
  Rabbit,
};

export const avatarList = Object.entries(avatarMap).map(([name, src]) => ({ name, src }));

export default avatarMap;
